import DetailUserTravel from '@/requests/travels/user/detailTravel';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/requests/viewTravel/$id/detailTravelUser',
)({
  component: TravelDetailPage,
})

function TravelDetailPage() {
  const { id } = Route.useParams();
  return <DetailUserTravel travelId={id} />
}